import { ListItem, AHIcon, Box, AHText } from "arkh";
import { FormattedMessage } from "react-intl";
import { useFragment, graphql } from "react-relay";
import { WorkspaceRecieversListItemButton_workspaceEntity$key } from "./__generated__/WorkspaceRecieversListItemButton_workspaceEntity.graphql";

export function ReciversListItemButton(props: {
  onPress: () => void;

  entity: WorkspaceRecieversListItemButton_workspaceEntity$key;
}) {
  const entity = useFragment(
    graphql`
      fragment WorkspaceRecieversListItemButton_workspaceEntity on WorkspaceEntity {
        potentialReceiverStores {
          __typename
        }

        receiverStores {
          __typename
        }

        topic {
          name
        }
      }
    `,
    props.entity
  );

  const totalStoreCount = entity.potentialReceiverStores.length;
  const selectedStoreCount = entity.receiverStores.length;

  return (
    <ListItem
      isFree
      onPress={props.onPress}
      left={<AHIcon type="store" color="text-secondary" />}
      border="border-primary"
    >
      <Box
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <ListItem.TitleSecondary>
          <FormattedMessage
            defaultMessage="Receivers"
            description="Workspace Todo Receivers title"
          />
        </ListItem.TitleSecondary>
        <AHText selectable={false} type="subtitle" color="primary">
          {entity.topic ? (
            <AHText spaceRight="medium" type="subtitle" color="darkText">
              {entity.topic?.name}
            </AHText>
          ) : null}
          <FormattedMessage
            description="WorkspaceTodoEditMainReceivers"
            defaultMessage="{selectedStoreCount}/{totalStoreCount} Units"
            values={{
              totalStoreCount: totalStoreCount,
              selectedStoreCount: selectedStoreCount,
            }}
          />
        </AHText>
      </Box>
    </ListItem>
  );
}
